import React, { Component } from 'react'
import { withRouter} from 'react-router-dom'
import { connect } from 'react-redux'
import {  newSection } from '../../actions/sections'
import {hideModal} from '../../actions/modals'
import NewSectionForm from '../../components/forms/NewSectionForm'
import Button from '../../components/uiKit/Button'


const colorOptions = [
	'blue',
	'purple',
	'red',
	'orange',
	'green',
	'sky',
	'pink',
	'teal',
	'grey',
]




class NewSectionContainer extends Component {

	constructor(){
		super()
		this.handleNewSection=this.handleNewSection.bind(this)
		this.createNewSections=this.createNewSections.bind(this)

		 this.state=({
			newSectionFormIds:[1,2,3,4,5,6,7,8],
			submitDisabled:false,
			submitLoading:false
		})
		
	}
	componentDidMount(){
		if(window.analytics){
			window.analytics.page('Add Class Modal')
		}
	}



	createNewSections(){
		this.setState({submitDisabled:true})//prevent dublicate form submissions
		this.setState({submitLoading:true})
		const forms=this.state.newSectionFormIds  
		let promises = []
		let sections=[]

		forms.map((sectionId, index) => { 
			const form=this.props.forms[`NewSection${sectionId}`]
			if(form.values.name  && form.values.name !== ''){
				promises.push(this.handleNewSection(form.values).then((response)=>{
				sections.push(response)}))
			}
			return null
		})
		Promise.all(promises).then(function () {
			//after creating, navigate to the first section
			const firstSection=sections[0]
			this.props.history.push(`/classes/${firstSection.id}`) 
		}.bind(this))


	}


	handleNewSection(data){
		return this.props.newSection(this.appendData(data))
	}



	//Add additional fields required for api to the data passed from the redux form
	appendData(data){
		const nowDate = new Date()
		return {
			...data, 
			'subject':'',
			'year':'',
			'archived':false,
			'clientModified':nowDate,
			'userCreated':nowDate
		}
	}


	render() {
		let canSubmit=false
		let classesToCreateCount=0
		const forms=this.state.newSectionFormIds  
		
		forms.map((sectionId, index) => { 
			const form=this.props.forms[`NewSection${sectionId}`]
			if(form){
				if(form.values.name  && form.values.name !== ''){
					canSubmit=true
					classesToCreateCount+=1
				}}
			return null
		})
		if(this.state.submitDisabled){
			canSubmit=false
		}

		let buttonText='Create Class'
		if(classesToCreateCount>1){
			buttonText='Create Multiple Classes'
		}



		return (        
			<div className='newSection'>
				<div className='newSection-explainText'>				
					For each class, just provide a name. We recommend something not too long, like 'AP Biology' or 'Monday Grade 9'. The class name will be visible to your students in Now Playing.
				</div>
				<div className='newSection-forms--container'>
					{this.state.newSectionFormIds.map((sectionId, index) => { 
						return(
						 <NewSectionForm 
						 autoFocus={index===0 ? true : false}
						 defaultColor={`${colorOptions[index]}`}
						 key={sectionId}
						 formName={`NewSection${sectionId}`} 
						 newSectionId={sectionId}
						 //removeNewSectionForm={this.removeNewSectionForm}
						 onSubmit={this.createNewSections}
						 tabIndex={index}   /> 
						)
					})
					}
				</div>

				<Button canSubmit={canSubmit} submitLoading={this.state.submitLoading} size='xLarge' label={buttonText} color={canSubmit ? 'blue' : 'gray'} type='submit' onClickFunction={this.createNewSections} />
					
			</div>
		)
	}
}

export default withRouter(connect(
	(state) => ({
		forms:state.form,
	}),
	{ newSection,hideModal}
)(NewSectionContainer))


// WEBPACK FOOTER //
// ./src/containers/sections/NewSectionContainer.js